/**
 * True when `backTo` is an ANCESTOR of `current` — i.e. the page a user arrived from is
 * the same place the breadcrumb already points at.
 *
 * `/certificates` → `/certificates/abc` is an ancestor (the breadcrumb reads
 * "Certificates / <cert>", so a plain back-link would say the same thing twice).
 * `/certificates/abc` → `/products/xyz` is NOT (nothing in the Products breadcrumb
 * mentions the certificate you came from, so a back-link is the only way back).
 *
 * Compared on path segments, not string prefix: a raw `startsWith` would treat `/tags`
 * as an ancestor of `/tags-shop`.
 *
 * Shared by `ReferrerBackLink` (suppresses the redundant back-link on a plain drill-in)
 * and `Breadcrumbs` (lets the parent segment link to `backTo` instead of the bare route,
 * so returning via the breadcrumb keeps the list's filters/sort/page — working-
 * conventions §42). One predicate, two consumers, so the two never disagree on what
 * counts as "the breadcrumb already covers this".
 */
export const isAncestorPath = (backTo: string, current: string): boolean => {
  const seg = (p: string) => p.split('?')[0].split('/').filter(Boolean)
  const from = seg(backTo)
  const here = seg(current)
  if (from.length >= here.length) return false
  return from.every((s, i) => s === here[i])
}
